import {FollowUpReasonsEffects} from './follow-up-reasons.effects';
import {FollowUpsEffects} from './follow-up.effects';

export const effects: Array<any> = [
  FollowUpReasonsEffects,
  FollowUpsEffects
];
export * from './follow-up-reasons.effects';
export * from './follow-up.effects';
